module.exports = __webpack_public_path__ + "static/media/logo__0015_Beacon.47e50921.png";